/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { Popup as l } from "@progress/kendo-react-popup";
import { classNames as a } from "@progress/kendo-react-common";
const r = "bottom", s = "top", m = (t) => {
  const o = t.popupSettings || {}, n = t.dir === "rtl" ? "right" : "left", c = e.useMemo(
    () => ({ horizontal: n, vertical: r }),
    [n]
  ), i = e.useMemo(
    () => ({ horizontal: n, vertical: s }),
    [n]
  );
  return /* @__PURE__ */ e.createElement(e.Fragment, null, t.input, t.button, /* @__PURE__ */ e.createElement(
    l,
    {
      style: {
        ...(o || {}).style,
        direction: t.dir
      },
      ...o,
      anchor: t.popupAnchor,
      anchorAlign: c,
      popupAlign: i,
      show: t.open,
      onOpen: t.onOpen,
      onClose: t.onClose,
      className: a("k-reset", o.className)
    },
    t.content
  ));
};
m.displayName = "KendoPickerComponent";
export {
  m as Picker
};
